import { getUserInfo } from '../reducers/getters'
import { TwinDictionary } from './dictionary'

export const sortCountries = (items: TwinDictionary) => {
    const user = getUserInfo()
    let country = 'ES'
    if (user && user.WorkingCenterId) {
        country = user?.WorkingCenters?.[user.WorkingCenterId]?.country || 'ES'
    }
    const countries: any[] = []
    for (const key in items) {
        const item = items[key]
        if (item.code === country) {
            countries.unshift({ text: item.name, value: item.code })
        }
        countries.push({ text: item.name, value: item.code })
    }
    return countries
}